/**
 * Le Club — 3D tilt on hover.
 *
 * Attach with data-leclub-tilt on any element. The card leans towards the
 * pointer and a soft highlight tracks across it. Pointer devices only, and
 * it stands down entirely under prefers-reduced-motion, so touch users and
 * anyone who asked for less movement get the flat card.
 *
 * The element's box is measured once on enter and reused for the rest of
 * the hover: no layout read per pointermove, and no animation-frame
 * dependency for something the browser already batches.
 *
 * Optional: data-tilt-max="8" to change the maximum lean in degrees.
 */
(function () {
  'use strict';

  function attach(el) {
    if (el.dataset.tiltBound) return;
    el.dataset.tiltBound = 'true';

    var max = parseFloat(el.dataset.tiltMax) || 7;
    var box = null;

    function measure() {
      var rect = el.getBoundingClientRect();
      box = rect.width && rect.height ? rect : null;
    }

    function track(event) {
      if (!box) return;
      // -0.5 .. 0.5 from the centre of the card
      var px = (event.clientX - box.left) / box.width - 0.5;
      var py = (event.clientY - box.top) / box.height - 0.5;
      el.style.setProperty('--tilt-x', (-py * max).toFixed(2) + 'deg');
      el.style.setProperty('--tilt-y', (px * max).toFixed(2) + 'deg');
      el.style.setProperty('--tilt-px', (px * 100 + 50).toFixed(1) + '%');
      el.style.setProperty('--tilt-py', (py * 100 + 50).toFixed(1) + '%');
    }

    function reset() {
      box = null;
      el.classList.remove('is-tilting');
      el.style.setProperty('--tilt-x', '0deg');
      el.style.setProperty('--tilt-y', '0deg');
    }

    el.addEventListener('pointerenter', function (event) {
      if (event.pointerType !== 'mouse') return;
      measure();
      if (!box) return;
      el.classList.add('is-tilting');
      track(event);
    });

    el.addEventListener('pointermove', function (event) {
      if (event.pointerType !== 'mouse') return;
      track(event);
    });

    el.addEventListener('pointerleave', reset);
    el.addEventListener('pointercancel', reset);
  }

  function initAll(scope) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    (scope || document).querySelectorAll('[data-leclub-tilt]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
